// @flow

import type { SearchState } from './types';
import {
  contentType,
} from '../content/types';

const keys = {
  studySet: 2,
  questionSet: 3,
  folder: 4,
};

const initialState: SearchState = {
  selectedChips: {
    [keys.studySet]: {
      selected: false,
      contextType: contentType.STUDY_SET,
    },
    [keys.questionSet]: {
      selected: false,
      contextType: contentType.QUESTION_SET,
    },
    [keys.folder]: {
      selected: false,
      contextType: contentType.FOLDER,
    },
  },
  selectedChipsAdvance: {
    [keys.studySet]: {
      selected: false,
      contextType: contentType.STUDY_SET,
    },
    [keys.questionSet]: {
      selected: false,
      contextType: contentType.QUESTION_SET,
    },
    [keys.folder]: {
      selected: false,
      contextType: contentType.FOLDER,
    },
  },
  selectedNarrowedFilter: {
    id: '23333444',
    label: 'Everywhere',
    icon: 'earth',
  },
  init: true,
  showAdvanceOptions: false,
};

export { initialState, keys };
